import { Product, ProductClass, ProductPrintFiles } from '@/typings/printful/product';
import api from './baseApi';

export const getProduct = (productId: number | string, store: string): Promise<Product> => {
    return api
        .get<Product>(`printful/products/${productId}`, {
            params: {
                shop: store
            },
            cache: {
                maxAge: 60 * 60 * 1000
            }
        })
        .then(({ data }) => data);
};

export const getProductsCatalog = async (store: string): Promise<ProductClass[]> => {
    const response = await api.get('printful/products', {
        params: {
            shop: store
        },
        cache: {
            maxAge: 60 * 60 * 1000
        }
    });

    return response.data;
};

export const getPrintfulPrintFiles = async (store: string, productId: number): Promise<ProductPrintFiles> => {
    const response = await api.get(`printful/printfiles/${productId}`, {
        params: {
            shop: store
        },
        cache: {
            maxAge: 60 * 60 * 1000
        }
    });

    return response.data;
};
